import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden bg-foreground-950 text-background-100 md:block">
        <div className="mx-auto flex h-9 w-full max-w-[1400px] items-center justify-between px-4 md:px-6 lg:px-10">
          <div className="flex items-center gap-2 text-xs tracking-wide">
            <span className="h-1.5 w-1.5 animate-hw-pulse rounded-full bg-accent-500"></span>
            <span>线报核验中心 · 第 072 期专题已上线</span>
          </div>
          <div className="flex items-center gap-5 text-xs text-background-200">
            <span>2026.09.12 周六</span>
            <a href="#desk" className="transition-colors hover:text-primary-300">
              <i className="ri-alarm-warning-line mr-1"></i>
              举报热线
            </a>
            <span className="flex items-center gap-2">
              <a href="#desk" aria-label="投稿邮箱" className="transition-colors hover:text-primary-300">
                <i className="ri-mail-line"></i>
              </a>
              <a href="#desk" aria-label="加密频道" className="transition-colors hover:text-primary-300">
                <i className="ri-shield-keyhole-line"></i>
              </a>
            </span>
          </div>
        </div>
      </div>

      <div
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-300 bg-background-50/95 backdrop-blur"
            : "border-transparent bg-background-50"
        }`}
      >
        <div className="mx-auto flex h-16 w-full max-w-[1400px] items-center justify-between gap-4 px-4 md:h-[72px] md:px-6 lg:px-10">
          <h1 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                <i className="ri-flashlight-fill text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span>黑网爆料</span>
                <span className="mt-1 font-body text-[10px] font-normal tracking-[0.28em] text-foreground-500">
                  HEIWANG LEAKS
                </span>
              </span>
            </a>
          </h1>

          <nav className="hidden items-center gap-7 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <button
              type="button"
              aria-label="搜索"
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <a
              href="#desk"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              匿名爆料
            </a>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:border-primary-400 lg:hidden"
            >
              <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-b border-background-300 bg-background-100 lg:hidden">
          <nav className="mx-auto flex w-full max-w-[1400px] flex-col px-4 py-3 md:px-6">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between border-b border-background-200 py-3 text-sm text-foreground-800 transition-colors last:border-0 hover:text-primary-600"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400"></i>
              </a>
            ))}
            <a
              href="#desk"
              onClick={() => setMenuOpen(false)}
              className="mt-3 inline-flex items-center justify-center rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50"
            >
              匿名爆料
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}